export default __webpack_public_path__ + "04df69b803539f57715a4bf5959604d9.png";